// environment.ts
// export const environment = {
//   production: false,
//   apiUrl: 'http://localhost:5000/api', 
//   socketUrl: 'http://localhost:5000' 
// };

// export const environment = {
//   production: false,
//  apiUrl: 'https://chat-back-production-2409.up.railway.app/api', 
//   socketUrl: 'https://chat-back-production-2409.up.railway.app'
// };

export const environment = {
  production: false,
  apiUrl: 'https://chat-back-0bvk.onrender.com/api', 
  socketUrl: 'https://chat-back-0bvk.onrender.com' 
};